export default __webpack_public_path__ + "static/service-engineering-banner-18cb4909600f585011923fb73f3974de.png";